import { useLayoutEffect, useState } from 'react'
import { breakpoints } from './breakpoints'

export const useHeadings = () => {
    const [ww, setWW] = useState(window.innerWidth)
    useLayoutEffect(() => {
        function updateSize() {
            setWW(window.innerWidth)
        }
        window.addEventListener('resize', updateSize)
        updateSize()
        return () => window.removeEventListener('resize', updateSize)
    }, [])
    return {
        sizes: {
            h1: {
                fontWeight: 'bold',
                fontSize: ww < breakpoints.sm ? '40px' : '68px',
            },
            h2: {
                fontWeight: 'bold',
                fontSize: ww < breakpoints.sm ? '26px' : '42px',
            },
            h3: { fontWeight: 'bold', fontSize: '26px' },
            h4: { fontWeight: 'bold', fontSize: '16px' },
            h5: { fontWeight: '500', fontSize: '16px' },
        },
    }
}
